import React from 'react';
import { ErrorBar } from '@agria/theme/src/components/errorBar/ErrorBar';
import { NetworkIssue } from '@agria/theme/src/components/icon';
import { useNetworkStatus } from '@agria/theme/src/context/NetworkContext';

export const ErrorBarNetworkIssue: React.FC = () => {
  const { isOnline } = useNetworkStatus();

  return (
    <ErrorBar
      icon={
        <NetworkIssue size="small" color="systemError100" aria-hidden="true" />
      }
      message={
        <>
          <strong>Your internet connection appears to be unstable.</strong>{' '}
          Check your connection and try again.
        </>
      }
      display={!isOnline}
    />
  );
};
